import { GameStateStatus, Suite } from './enums';

/*
 * card-rules — the single source of truth for whether a card may be played,
 * shared by the server (validateCardV2) and the client (unplayable-card
 * indicators) so the two never disagree.
 */

export interface CardPlayabilityContext {
  /** The current game-state status. */
  status: GameStateStatus;
  /** Suit led this trick (only meaningful while following, i.e. Playing). */
  trickSuite?: Suite;
  /** Trump suit for the hand. */
  trumpSuite?: Suite;
  /** Suits of every card currently in the player's hand (to test "void"). */
  handSuites: Suite[];
}

// A card is playable UNLESS we're following a trick (status Playing), the card
// is neither the led (trick) suit nor trump, and the player still holds a card
// of the led suit — in which case they must follow suit. Leading a trick (any
// non-Playing status) allows any card.
export function isCardPlayable(cardSuite: Suite, ctx: CardPlayabilityContext): boolean {
  if (ctx.status !== GameStateStatus.Playing) return true;
  if (cardSuite === ctx.trickSuite || cardSuite === ctx.trumpSuite) return true;
  return !ctx.handSuites.includes(ctx.trickSuite as Suite);
}
